





















































import Vue from "vue";
import { Mutations } from "@/store/mutations";

/**
 * Show and modify values in the current Show model
 */
export default Vue.extend({
  name: "FileModal",
  computed: {
    showTitle: {
      get(): string {
        return this.$store.getters.getShowTitle;
      },
      set(title: string): void {
        this.$store.commit(Mutations.SET_SHOW_TITLE, title);
      },
    },

    frontHashOffsetY: {
      get(): number {
        return this.$store.getters.getFrontHashOffsetY;
      },
      set(offsetY: number): void {
        this.$store.commit(Mutations.SET_FRONT_HASH_OFFSET_Y, offsetY);
      },
    },

    backHashOffsetY: {
      get(): number {
        return this.$store.getters.getBackHashOffsetY;
      },
      set(offsetY: number): void {
        this.$store.commit(Mutations.SET_BACK_HASH_OFFSET_Y, offsetY);
      },
    },

    middleOfField: {
      get(): number {
        return this.$store.getters.getMiddleOfField;
      },
      set(middle: number): void {
        this.$store.commit(Mutations.SET_MIDDLE_OF_FIELD, middle);
      },
    },
  },
});
